// extracted by mini-css-extract-plugin
module.exports = {"login-button":"Navigation_login-button__tuBCu","collapse":"Navigation_collapse__WG1FO"};